var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z","className":""}));
}

MenuInline.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fal","data-icon":"bars","role":"img","viewBox":"0 0 448 512","height":"48.004"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
